// Framework imports
import { Component, ElementRef, Input, ViewChild } from '@angular/core';

import { Text } from '../../../../@itc-core/common/text.constants';
import { whiteLabelConfig } from '../../../../config/config';
import { DashboardStrikeRateModel } from './common/dashboard-strike-rate.models';

@Component({
	selector: 'paint-dashboard-strike-rate',
	templateUrl: './dashboard-strike-rate.component.html',
	styleUrls: ['./dashboard-strike-rate.component.scss'],
})
export class DashboardStrikeRateComponent {
	@ViewChild('strikeRateNumberProgressBar', { static: true })
	private strikeRateNumberProgressBarElement: ElementRef;

	@ViewChild('strikeRateAmountProgressBar', { static: true })
	private strikeRateAmountProgressBarElement: ElementRef;

	@ViewChild('profitPercentageProgressBar', { static: true })
	private profitPercentageProgressBarElement: ElementRef;

	@Input()
	public set inputConfig(config: DashboardStrikeRateModel) {
		this._inputConfig = config;
		// The progress bar will show the amount of won projects compared to total amount of projects submitted + won
		if (this._inputConfig.projectsSubmitted + this._inputConfig.projectsWon === 0) {
			this.strikeRateNumberProgressBarPercentage = 0;
			this.strikeRateAmountProgressBarPercentage = 0;
			this.profitProgressBarPercentage = 0;
		} else {
			this.strikeRateNumberProgressBarPercentage = this._inputConfig.strikeRate;
			const sumRevenues = this._inputConfig.revenueWon + this._inputConfig.revenueLost + this._inputConfig.revenueSubmitted;
			this.strikeRateAmountProgressBarPercentage = (this._inputConfig.revenueWon / this._inputConfig.revenueSubmitted) * 100;
			this.profitProgressBarPercentage = this._inputConfig.profitTotalPercent;
		}
	}
	public get inputConfig(): DashboardStrikeRateModel {
		return this._inputConfig;
	}

	public strikeRateNumberProgressBarPercentage: number;
	public strikeRateAmountProgressBarPercentage: number;
	public profitProgressBarPercentage: number;
	public textConstants: typeof Text = Text;
	public whiteLabelConfig = whiteLabelConfig.dashboard.dashboardStrikeRate;

	private _inputConfig: DashboardStrikeRateModel;

	constructor() {}
}
